import * as React from 'react';
import { ChangeEvent } from 'react';
import { TextField } from '@material-ui/core';
import styled from 'styled-components';

interface Props {
  keyword: string;
  onChangeKeyword: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyDownKeyword?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  maxLength?: number;
  error?: boolean;
  helperText?: string;
  // [EN] Only set it when the input shares its row with another control. The
  //      default keeps every existing caller at the width it already had.
  // [KO] 입력이 다른 컨트롤과 한 줄을 나눠 쓸 때만 지정한다. 기본값은 기존 호출부를
  //      전부 지금 폭 그대로 둔다.
  width?: string;
}

const KeywordInput = ({
  error,
  helperText,
  keyword,
  onChangeKeyword,
  onKeyDownKeyword,
  placeholder = '',
  maxLength = 200,
  width = '50%',
}: Props) => {
  return (
    <KeywordInputBlock width={width}>
      <TextField
        error={error}
        helperText={helperText}
        value={keyword}
        onChange={onChangeKeyword}
        placeholder={placeholder}
        fullWidth
        inputProps={{
          maxLength,
        }}
        onKeyDown={onKeyDownKeyword}
      />
    </KeywordInputBlock>
  );
};

export default KeywordInput;

const KeywordInputBlock = styled.div<{ width: string }>`
  display: flex;
  flex-direction: row;
  width: ${props => props.width};
  padding: ${props => props.theme.spacing(1.5)}px 0;
`;
